import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts"
import { useMediaQuery } from "@mui/material"
import { useTheme } from "@mui/material/styles"

const ChartPie = ({ summaryData }) => {
  if (!summaryData || !summaryData.cuentasAgrupadas) {
    return <p className="text-sm text-muted">No hay datos para mostrar</p>
  }

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const chartHeight = isMobile ? 260 : 400

  const { cuentasAgrupadas, montoTotalGeneral } = summaryData
  
  const allData = Object.entries(cuentasAgrupadas)
    .map(([key, value]) => ({
      name: key,
      value: montoTotalGeneral > 0 ? Number(((value / montoTotalGeneral) * 100).toFixed(1)) : 0
    }))
    .filter(item => item.value > 0)
    .sort((a, b) => b.value - a.value)

  const top5 = allData.slice(0, 3)
  const others = allData.slice(3)

  // Sumar el resto como "Otros"
  const othersTotal = others.reduce((acc, item) => acc + item.value, 0)
  if (othersTotal > 0) {
    top5.push({ name: "Otros", value: Number(othersTotal.toFixed(1)) })
  }

  const COLORS = ["#00C49F", "#FFBB28", "#FF8042", "#0088FE"]
  
  /*const COLORS = generateHSLColors(top5.length)
  function generateHSLColors(numColors) {
    return Array.from({ length: numColors }, (_, i) => `hsl(${(i * 137) % 360}, 70%, 50%)`)
  }*/

  return (
    <ResponsiveContainer width="100%" height={chartHeight}>
      <PieChart>
        <Pie
          data={top5}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={80}
          paddingAngle={3}
          dataKey="value"
        >
          {top5.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Legend
          layout="horizontal"
          align="center"
          horizontalAlign="middle"
          wrapperStyle={{
            fontSize: "12px",
            width: "100%",
            color: "rgb(var(--muted))"
          }}
          formatter={(value, entry) => `${value}: ${entry.payload.value}%`}
        />
      </PieChart>
    </ResponsiveContainer>
  )
}

export default ChartPie
